import { Endereco } from './endereco';

export class EnderecoSuper {

    public endereco: Endereco;

    set Endereco(endereco: any) {
        this.endereco = new Endereco(endereco);
    }

    get obterEndereco(): Endereco {
        return this.endereco;
    }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/endereco-super.ts